import Env from '../../base/env';
import Channels from '../../base/channels';
import Waypoint from '../../vendor/waypoints'
import 'babel-polyfill'

class PlayerCustom
{
    constructor(view=null)
    {
        if(view != null)
        {
            this.view = view
            this.$playersContext = this.view.querySelectorAll('.jsPlayer--context')
            this.players = []
            this.instancesAutoplay = []
            // this.redraw()
            this.install()
        }
        else
        {
            return
        }
    }

    destroy()
    {
        if(typeof this.instancesAutoplay !== 'undefined') {
            for(let i = 0; i < this.instancesAutoplay.length; i++) {
                const instance = this.instancesAutoplay[i]
                instance.destroy()
            }
        }
    }

    size(_context)
    {
        const $context = _context
        const $embed = $context.querySelector('.jsPlayer--receptor')
        const realDimensions = { width : $embed.getAttribute('data-width') , height : $embed.getAttribute('data-height') }
        const embedHeight = ($embed.getBoundingClientRect().width * realDimensions.height) / realDimensions.width

        $context.style.height = `${embedHeight}px`;
    }

    redraw()
    {
        Channels.on('window::smartresize',()=>
        {
            for(let $context of this.$playersContext) {
                // const $context = e
                // this.size($context);
            }
        })
    }

    install()
    {
        const self = this

        for(let i = 0; i < this.$playersContext.length; i++)
        {
            const e = this.$playersContext[i];
            const $context = e;
            const $video = e.querySelector('.jsPlayer--video')

            // Event autoplay
            if($context.classList.contains('jsWaypoint--autoplay') === true) {
                const instanceAutoplay = new Waypoint({
                    element: $context,
                    handler: (direction)=> {
                        if(Env.mobile && Env.ios) {
                            $context.classList.add('video--iosAutoplay')
                            const $poster =  $context.querySelector('.poster')
                            const dimensions = $video.getBoundingClientRect()
                            if($poster != null) {
                                $video.poster = $poster.getAttribute('src')
                            }
                        } else {
                            $video.play()
                            setTimeout(() => {
                                $context.classList.add('video--isPlaying')
                            }, 500);
                        }
                    },
                    offset: '70%'
                });
                this.instancesAutoplay.push(instanceAutoplay)
            }

            const id = 'playerBody-'+Env.framework.toolbox.guid()

            if($context.classList.contains('jsWaypoint--autoplay') === true) {
                if(Env.mobile && Env.ios) {
                    $context.addEventListener('click',()=>{
                        $video.play()
                        $context.classList.add('video--iosAutoplaying')
                    })
                }
            }

            if($context.classList.contains('with--controls') === true) {
                const $contextVolume = e.querySelector('.jsPlayer--contextVolume')
                const $triggersVolume = $contextVolume.querySelectorAll('.jsPlayer--triggerVolume')
                const $triggerTimeline = e.querySelector('.jsPlayer--triggerTimeline')
                const $triggerFullscreen = e.querySelector('.jsPlayer--triggerFullscreen')
                const $triggerPlaypause = e.querySelector('.jsPlayer--triggerPlaypause')
                const $triggerPlay = e.querySelector('.jsPlayer--trigger')
                const $duration = e.querySelector('.jsPlayer--duration')
                const $currentTime = e.querySelector('.jsPlayer--currentTime')
                const $progress = e.querySelector('.jsPlayer--progress')
                const $buffer = e.querySelector('.jsPlayer--buffer')

                // this.size($context);

                this.players[i] = {}
                this.players[i].loaded = false
                this.players[i].inactivityTimeout = false
                this.players[i].userActivity = false
                this.players[i].buffering = false
                this.players[i].video = $video

                // hide controls
                $video.removeAttribute('controls')
                $video.removeAttribute('loop')
                $video.removeAttribute('muted')


                // meta are ready
                const loadMetaData = ()=>
                {
                    this.players[i].loaded = true
                    // duration
                    const duration = $video.duration
                    const durationStr = Env.framework.toolbox.calculateTime(duration,duration)
                    $currentTime.innerHTML = '00:00'
                    $duration.innerHTML = ' / '+durationStr
                    this.players[i].totalDuration = duration
                    // volume
                    $video.volume = 1
                    $contextVolume.classList.add('for--4')
                    // buffering
                    this.players[i].buffering = setTimeout(startBuffer, 1000);
                }

                //display video buffering bar
                const startBuffer = ()=>
                {
                    const currentBuffer = $video.buffered.end(0);
                    const duration = this.players[i].totalDuration;
                    var progression = 100 * currentBuffer / duration;
                    $buffer.style.width = progression+'%';

                    if(currentBuffer < duration) {
                        this.players[i].buffering = setTimeout(startBuffer, 1000);
                    }
                    else
                    {
                        clearTimeout(this.players[i].buffering)
                    }
                };

                // timeupdate
                $video.addEventListener('timeupdate',()=>
                {
                    const current = $video.currentTime;
                    const progression = current/this.players[i].totalDuration
                    let timeToDisplay = Env.framework.toolbox.calculateTime(current,this.players[i].totalDuration)
                    $progress.style.width = progression*100 + '%'
                    $currentTime.innerHTML = timeToDisplay
                    // User Activity
                    if (this.players[i].userActivity)
                    {
                        this.players[i].inactivityTimeout = setTimeout(()=> {
                            this.players[i].userActivity = false
                        }, 4000);
                    }
                    if(this.players[i].userActivity == true)
                    {
                        $context.classList.add('show-controls')
                    }
                    else
                    {
                        $context.classList.remove('show-controls')
                    }
                },false)

                // check playing
                $video.addEventListener('play',()=>
                {
                    $context.classList.remove('video--isPausing')
                    $context.classList.add('video--isPlaying')
                    for(let w = 0; w < this.players.length ; w++)
                    {
                        const player = this.players[w]
                        if(player.video.paused == false && w != i)
                        {
                            player.video.pause()
                        }
                    }
                },false)

                // check pausing
                $video.addEventListener('pause',()=>
                {
                    $context.classList.remove('video--isPlaying')
                    $context.classList.add('video--isPausing')
                },false)

                // check ended
                $video.addEventListener('ended',()=>
                {
                    if($context.classList.contains('video--isPausing')) $context.classList.remove('video--isPausing')
                    if($context.classList.contains('video--isPlaying')) $context.classList.remove('video--isPlaying')
                },false)

                // Event Play
                $triggerPlay.addEventListener('click',()=>
                {
                    const status = $video.paused
                    if(status == true)
                    {
                        const playPromise = $video.play()
                        if (playPromise !== undefined) {
                            playPromise.then(_ => {
                                if(this.players[i].loaded == false)
                                {
                                    loadMetaData()
                                }
                            })
                            .catch(error => {
                                $context.classList.remove('video--isPlaying')
                                $context.classList.add('video--isPausing')
                            });
                        }
                    }
                    else
                    {
                        $video.pause()
                    }
                })

                // Event Playpause
                $triggerPlaypause.addEventListener('click',(event)=>{
                    if($context.classList.contains('video--isPlaying'))
                    {
                        $video.pause();
                    }
                    else
                    {
                        const playPromise = $video.play();
                        if (playPromise !== undefined) {
                            playPromise.then(_ => {

                            })
                            .catch(error => {

                            });
                        }

                    }
                },false)

                // Event Volume
                for(let btn of $triggersVolume)
                {
                    btn.addEventListener('click',(event)=>{
                        const newVolume = event.target.getAttribute('data-value')
                        self.setVolume($video,$contextVolume,newVolume)
                    },false)
                }

                // Event progress
                $triggerTimeline.addEventListener('click',(event)=>{
                    const ratio = event.offsetX/Math.floor(event.target.getBoundingClientRect().width)
                    const setSeek = this.players[i].totalDuration * ratio
                    $video.currentTime = setSeek
                },false)

                // Event fullscreen
                $triggerFullscreen.addEventListener('click',(event)=>{
                    const fn = ['requestFullScreen','mozRequestFullScreen','webkitRequestFullScreen']
                    for(let f of fn) {
                        if(typeof $video[f] == 'function')
                        {
                            $video[f]()
                            return false
                        }
                    }
                },false)



                // Event user activity
                $context.addEventListener('mousemove',(event)=>
                {
                    clearTimeout(this.players[i].inactivityTimeout)
                    this.players[i].userActivity = true
                })

                // Event controls
                $context.addEventListener('mouseenter',()=>
                {
                    $context.classList.add('show-controls')
                },false)
                $context.addEventListener('mouseleave',()=>
                {
                    clearTimeout(this.players[i].inactivityTimeout)
                    this.players[i].userActivity = false
                    $context.classList.remove('show-controls')
                },false)
            }
        }
    }

    setVolume(_video,_target,_volume)
    {
        const $video = _video
        const $target = _target

        $video.volume = _volume

        $target.classList.remove('for--1')
        $target.classList.remove('for--2')
        $target.classList.remove('for--3')
        $target.classList.remove('for--4')
        if(_volume > 0 && _volume <= 0.25)
        {
            $target.classList.add('for--1')
        }
        else if(_volume > 0.26 && _volume <= 0.50)
        {
            $target.classList.add('for--2')
        }
        else if(_volume > 0.51 && _volume <= 0.75)
        {
            $target.classList.add('for--3')
        }
        else if(_volume > 0.76 && _volume <= 1)
        {
            $target.classList.add('for--4')
        }
    }
}

export default PlayerCustom;